import React, { FC, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { useHistory } from 'react-router';
import { RootState } from '../../store/reducers';
import { VISITOR_COMPLETE_DISPATCH_INIT } from '../../store/actions';
import MyPageLayout from '../../components/Layouts/MyPage/MyPageLayout.index';
import './style/RegisterComplete.scss';
import googleCalendarIcon from './style/img/google-calendar.svg';

dayjs.extend(utc);
dayjs.extend(timezone);

const RegisterComplete: FC = () => {
  const visitorData = useSelector((state: RootState) => state.visitorRegisterConfirm.visitorRegisterConfirm);
  const history = useHistory();
  const dispatch = useDispatch();
  const handleBackToReservation = () => {
    dispatch({
      type: VISITOR_COMPLETE_DISPATCH_INIT,
    });
    history.push('/');
  };

  const buildGoogleCalendarUrl = (params: { text: string; dates: string; location: string; details: string }) => {
    return (
      'https://calendar.google.com/calendar/render?action=TEMPLATE' +
      `&text=${encodeURIComponent(params.text)}` +
      `&dates=${encodeURIComponent(params.dates)}` +
      `&ctz=${encodeURIComponent('Asia/Tokyo')}` +
      `&location=${encodeURIComponent(params.location)}` +
      `&details=${encodeURIComponent(params.details)}`
    );
  };

  const onClickGoogleCalendarAdd = useCallback(() => {
    const simpleAuthUrl = `${window.location.origin}/simpleAuth`;
    const scheduleDate = dayjs(visitorData.contentsDate).tz('Asia/Tokyo').format('YYYYMMDD');
    const endDate =
      visitorData.endTime === '0000' ? dayjs(scheduleDate).add(1, 'day').format('YYYYMMDD') : scheduleDate;
    const dates = `${scheduleDate}T${visitorData.startTime}00/${endDate}T${visitorData.endTime}00`;
    const location = `${visitorData.shopName || ''}, ${visitorData.clubAddress || ''}`;
    const details = `${visitorData.contentsName}\nスペース\u3000${visitorData.eqsName}\n\n<a href="${simpleAuthUrl}">予約の詳細</a>`;
    window.open(
      buildGoogleCalendarUrl({
        text: visitorData.contentsName,
        dates,
        location,
        details,
      }),
      '_blank',
      'noopener,noreferrer',
    );
  }, [visitorData]);

  return (
    <>
      <MyPageLayout>
        <main className="main-layout l-main register-complete-page">
          <section className="p-title-area">
            <p className="c-title">予約が完了しました</p>
          </section>
          <section className="p-content-area u-gap50">
            <div className="p-content-area__column p-content-area__column--width600 u-gap0 u-sp-gap7">
              <p className="c-read">
                MIRA fitnessの体験・見学予約が完了しました。
                <br />
                ご入力されたメールアドレスへ、ご予約内容をお送りしております。
                <br />
                メールからご予約内容の確認、変更、キャンセルが可能です。
              </p>
            </div>
          </section>
          <section className="p-content-area u-gap50">
            <div className="p-content-area__text-group">
              <button type="button" className="p-content-area__cancel-link c-link" onClick={onClickGoogleCalendarAdd}>
                <img
                  src={googleCalendarIcon}
                  alt="Googleカレンダーに追加する"
                  className="p-content-area__google-calendar-icon"
                />
                <span className="p-content-area__google-calendar-text">Googleカレンダーに追加する</span>
              </button>
            </div>
          </section>
          <section className="p-button-area">
            <button
              type="button"
              className="c-button c-button--secondary c-button--large"
              onClick={handleBackToReservation}
            >
              店舗選択へ戻る
            </button>
          </section>
        </main>
      </MyPageLayout>
    </>
  );
};

export default RegisterComplete;
